//导入vue
import Vue from "vue";
//导入路由
import VueRouter from "vue-router";
//注册路由
Vue.use(VueRouter);

import home from "../views/home";
import client from "../views/client";
import listing from "../views/listing";
import userInfo from "../views/userInfo";
import comments from "../views/comments";
import AutoLogin from "../views/AutoLogin";
import operatingRecord from "../views/operatingRecord";
import checkStatus from "../views/checkStatus";
import Login from "../views/Login";
import forgotpass from '../views/forgotPass'
import changepass from '../views/changePass'
import Cpdf from '../views/Cpdf/Cpdf.vue'
import freeGift from '../views/freeGift/FreeGift.vue'
import gift from '../views/freeGift/gift/Gift.vue'
import findid from '../views/freeGift/findid/Findid.vue'
// 后台homeFreeGift
import homeFreeGift from '../views/homeFreeGift/HomeFreeGift.vue'
// 后台homeAutoLoginFreeGift
import autoLoginFreeGift from '../views/homeAutoLoginFreeGift/HomeAutoLoginFreeGift.vue'
// 查询成功跳转
import warrantyActivated from '../views/freeGift/warrantyActivated/WarrantyActivated.vue'
// 我想要这份礼物跳转 shareExperience
import shareExperience from '../views/freeGift/shareExperience/ShareExperience.vue'
// 填写form表单第一次跳转
import shareExperience2 from '../views/freeGift/shareExperience2/ShareExperience2.vue'
// 填写form表单第二次跳转（1-3跳转）
import shareExperience4 from '../views/freeGift/shareExperience4/ShareExperience4.vue'
// 填写form表单第二次跳转（4-5跳转）
import shareExperience3 from '../views/freeGift/shareExperience3/ShareExperience3.vue'
// code返回201跳转页面
import noOrderId from '../views/freeGift/noOrderId/NoOrderId.vue'


// 创建路由对象,导出去
const router = new VueRouter({//定义路由
  routes:[
      // {path:'/',redirect:'/login'},//根路径
      {path:'/',redirect:'/gift',meta: { unRequiresAuth: true,keepAlive:false,isBack:false}},//根路径
      {path:'/login',meta: { unRequiresAuth: true,keepAlive:false,isBack:false},name: "login",component:Login},
      // {path:'/gift',meta: { unRequiresAuth: true ,keepAlive:false,isBack:false},name: "gift",component:gift},
      // {path:'/freeGift',meta: { unRequiresAuth: true ,keepAlive:false,isBack:false},name: "freeGift",component:freeGift},
      {path:'/Cpdf',meta: { unRequiresAuth: true,keepAlive:false,isBack:false },name: "Cpdf",component:Cpdf},
      { path: "/checkStatus",meta: { unRequiresAuth: true ,keepAlive:false,isBack:false}, name: "checkStatus", component: checkStatus },
      { path: "/forgotpass",meta: { unRequiresAuth: true,keepAlive:false,isBack:false }, name: "forgotpass", component: forgotpass },
      { path: "/changepass",meta: { unRequiresAuth: true ,keepAlive:false,isBack:false}, name: "changepass", component: changepass },
        {
              path: "/home",
              name: "home",
              component: home,
              // 路由元信息，定义各个页面的角色数组
              meta: {
                roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
              },
              children: [
                {
                  path: "/client",
                  name: "client",
                  component: client,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"],
                    keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/listing",
                  name: "listing",
                  component: listing,
                  meta: {
                    roles: ["Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/userInfo",
                  name: "userInfo",
                  component: userInfo,
                  meta: {
                    roles: ["Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/comments",
                  name: "comments",
                  component: comments,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/AutoLogin",
                  name: "AutoLogin",
                  component: AutoLogin,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/operatingRecord",
                  name: "operatingRecord",
                  component: operatingRecord,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/home/freeGift",
                  name: "homeFreeGift",
                  component: homeFreeGift,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                {
                  path: "/home/autoLoginFreeGift",
                  name: "autoLoginFreeGift",
                  component: autoLoginFreeGift,
                  meta: {
                    roles: ["Support", "Seller", "Admin", "Suadmin"], keepAlive:false,isBack:false
                  },
                },
                
              ],
        },
      {path:'/freeGift',meta: { unRequiresAuth: true, keepAlive:true,isBack:true},name: "freeGift",component:freeGift,
      children:[
        {path:'/gift',meta:{ unRequiresAuth: true , keepAlive:true,isBack:true},name: "gift",component:gift},
        {path:'/findid',meta: { unRequiresAuth: true , keepAlive:true,isBack:true},name: "findid",component:findid},
        {path:'/warranty-activated',meta: { unRequiresAuth: true, keepAlive:true,isBack:true },name: "warrantyActivated",component:warrantyActivated},
        {path:'/share-experience',meta: { unRequiresAuth: true, keepAlive:true,isBack:true },name: "shareExperience",component:shareExperience},
        {path:'/share-experience-2',meta: { unRequiresAuth: true, keepAlive:true,isBack:true },name: "shareExperience2",component:shareExperience2},
        {path:'/share-experience-3',meta: { unRequiresAuth: true , keepAlive:true,isBack:true},name: "shareExperience3",component:shareExperience3},
        {path:'/share-experience-4',meta: { unRequiresAuth: true , keepAlive:true,isBack:true},name: "shareExperience4",component:shareExperience4},
        {path:'/noOrderId',meta: { unRequiresAuth: true, keepAlive:true,isBack:true },name: "noOrderId",component:noOrderId},
      ]},
      
  ]
})

router.beforeEach((to,from,next)=>{
  if (to.meta.unRequiresAuth){
      next()
  } else {
    var oldTime = window.localStorage.getItem('setTime')
    var timestamp = new Date().getTime()
    if(oldTime < timestamp){
      localStorage.removeItem('Authorization')
    }

      if (localStorage.getItem('Authorization')){
          next()
      }
       else { 
          return router.push({path:'/login'})
      }
  }
})

// router.beforeRouteEnter(to, from, next) {
// if (from.name == 'confirm') {
// to.meta.isBack = true;
// }
// next();
// }
// router.beforeRouteLeave((to, from, next)=>{
//   console.log(to.name);
// })
// beforeRouteLeave(to, from, next){
//   console.log(to.name);
//     // if (to.name == "Detail"){
//     //     from.meta.keepAlive = true;
//     // }else{
//     //     from.meta.keepAlive = false;
//     // }
//     // next();
// }
//暴露router
export default router;
